import { Color } from "../defines/colors"
import { ItemType, MapID } from "../defines/enums"
import { PlayerDefaults } from "../defines/values"
import { Player } from "../player/player"

export function displayOptic(player: Player): string {
  let output = `%c{#fff}%b{#000}none`
  switch (player.optic) {
    case ItemType.OPTIC_YELLOW:
      output = `%c{${Color.PIGMENT_LIGHT_YELLOW}}%b{#000}yellow`
      break
    case ItemType.OPTIC_RED:
      output = `%c{${Color.PIGMENT_LIGHT_RED}}%b{#000}red`
      break
    case ItemType.OPTIC_MAGENTA:
      output = `%c{${Color.PIGMENT_LIGHT_MAGENTA}}%b{#000}magenta`
      break
    case ItemType.OPTIC_BLUE:
      output = `%c{${Color.PIGMENT_LIGHT_BLUE}}%b{#000}blue`
      break
    case ItemType.OPTIC_CYAN:
      output = `%c{${Color.PIGMENT_LIGHT_CYAN}}%b{#000}cyan`
      break
    case ItemType.OPTIC_GREEN:
      output = `%c{${Color.PIGMENT_LIGHT_GREEN}}%b{#000}green`
      break
    default:
      break
  }

  return output
}

export function getLevelExperience(level: number): number {
  switch (level) {
    case 2:
      return PlayerDefaults.EXP_LEVEL2
    case 3:
      return PlayerDefaults.EXP_LEVEL3
    case 4:
      return PlayerDefaults.EXP_LEVEL4
    case 5:
      return PlayerDefaults.EXP_LEVEL5
    case 6:
      return PlayerDefaults.EXP_LEVEL6
    case 7:
      return PlayerDefaults.EXP_LEVEL7
    case 8:
      return PlayerDefaults.EXP_LEVEL8
    case 9:
      return PlayerDefaults.EXP_LEVEL9
    case 10:
      return PlayerDefaults.EXP_LEVEL10
  }

  return 0
}

export function unlockAllItems(player: Player): void {
  const allKeys = [
    MapID.January,
    MapID.February,
    MapID.March,
    MapID.April,
    MapID.May,
    MapID.June,
    MapID.July,
    MapID.August,
    MapID.September,
    MapID.October,
    MapID.November,
    MapID.December,
  ]

  const equipment = [
    ItemType.EQUIPMENT_HEAD1,
    ItemType.EQUIPMENT_HEAD2,
    ItemType.EQUIPMENT_HEAD3,
    ItemType.EQUIPMENT_HEAD4,
    ItemType.EQUIPMENT_HEAD5,
    ItemType.EQUIPMENT_HEAD6,
    ItemType.EQUIPMENT_HEAD7,
    ItemType.EQUIPMENT_HEAD8,

    ItemType.EQUIPMENT_TORSO1,
    ItemType.EQUIPMENT_TORSO2,
    ItemType.EQUIPMENT_TORSO3,
    ItemType.EQUIPMENT_TORSO4,
    ItemType.EQUIPMENT_TORSO5,
    ItemType.EQUIPMENT_TORSO6,
    ItemType.EQUIPMENT_TORSO7,
    ItemType.EQUIPMENT_TORSO8,

    ItemType.EQUIPMENT_FEET1,
    ItemType.EQUIPMENT_FEET2,
    ItemType.EQUIPMENT_FEET3,
    ItemType.EQUIPMENT_FEET4,
    ItemType.EQUIPMENT_FEET5,
    ItemType.EQUIPMENT_FEET6,
    ItemType.EQUIPMENT_FEET7,
    ItemType.EQUIPMENT_FEET8,

    ItemType.EQUIPMENT_WEAPON1,
    ItemType.EQUIPMENT_WEAPON2,
    ItemType.EQUIPMENT_WEAPON3,
    ItemType.EQUIPMENT_WEAPON4,
    ItemType.EQUIPMENT_WEAPON5,
    ItemType.EQUIPMENT_WEAPON6,
    ItemType.EQUIPMENT_WEAPON7,
  ]

  const optics = [
    ItemType.OPTIC_RED,
    ItemType.OPTIC_GREEN,
    ItemType.OPTIC_BLUE,
    ItemType.OPTIC_YELLOW,
    ItemType.OPTIC_MAGENTA,
    ItemType.OPTIC_CYAN,
  ]

  const gizmos = [
    ItemType.EQUIPMENT_GIZMO_NONE,
    ItemType.EQUIPMENT_GIZMO1,
    ItemType.EQUIPMENT_GIZMO2,
    ItemType.EQUIPMENT_GIZMO3,
    ItemType.EQUIPMENT_GIZMO4,
    ItemType.EQUIPMENT_GIZMO5,
  ]

  allKeys.forEach((k) => {
    player.addKey(k)
  })

  equipment.forEach((e) => {
    player.addEquipment(e)
  })

  optics.forEach((o) => {
    player.addOptic(o)
  })

  gizmos.forEach((g) => {
    player.addEquipment(g)
  })

  window.engine.requestPlayerSaveState()

  window.engine.sendMessage("You now have all keys/optics/equipment")

  return
}
